/* tslint:disable */
/* eslint-disable */
/**
 * Modulos Platform API v2
 * API for the Modulos Platform.
 *
 * The version of the OpenAPI document: 2.5.7
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { HTTPValidationError } from '../model';
// @ts-ignore
import type { Job } from '../model';
// @ts-ignore
import type { JobAggregate } from '../model';
// @ts-ignore
import type { JobCreate } from '../model';
// @ts-ignore
import type { JobEnabledUpdate } from '../model';
// @ts-ignore
import type { JobEntityType } from '../model';
// @ts-ignore
import type { JobExpanded } from '../model';
// @ts-ignore
import type { JobPaginated } from '../model';
// @ts-ignore
import type { JobSorting } from '../model';
// @ts-ignore
import type { JobStatus } from '../model';
// @ts-ignore
import type { JobUpdate } from '../model';
// @ts-ignore
import type { ModulosPlatformBackendV2DomainEntitiesJobRunAggregate } from '../model';
// @ts-ignore
import type { Run } from '../model';
// @ts-ignore
import type { RunExpandedPaginated } from '../model';
// @ts-ignore
import type { RunPaginated } from '../model';
// @ts-ignore
import type { RunSorting } from '../model';
// @ts-ignore
import type { RunUpdate } from '../model';
// @ts-ignore
import type { StepPaginated } from '../model';
// @ts-ignore
import type { StepSorting } from '../model';
/**
 * JobsApi - axios parameter creator
 */
export const JobsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Create a job for a project.  The authenticated user becomes the job\'s creator. ``project_id`` is read from the request body, which is also how the RBAC dependency resolves the project. The job\'s ``entity_types`` are derived from ``configuration``: one entry per referenced entity type with the number of entities it covers (``count``) and how many of that type the job runs once container entities are expanded (``resolved``), followed by an entry per type its containers expand into (``count`` 0, ``resolved`` > 0). A container is never runnable itself, so it reports ``resolved`` 0.  A ``control_assessment`` entry references *controls*: each id is a control the job assesses with the control assessment agent, producing and storing one assessment per run.  A ``configuration`` entry may omit ``ids`` (or send ``null``) to select *every* entity of that type in the project: all of the project\'s ``test``s or ``agent_test``s, every control it assesses (for ``control_assessment``, excluding archived ones), all of its ``project_risk`` containers, or — for ``risk_threat`` — every threat held by every project risk. The selection is frozen into the job at creation, exactly as if each entity had been picked by hand, so entities added to the project later do not join the job and the response already lists the ids it captured. A type the project holds none of is rejected with 422, like an empty ``configuration``.  When the schedule\'s frequency is ``immediately`` the job runs once right after creation (a Run and its Steps are started) and is never scheduled to repeat. A job created disabled never executes, so the immediate run is skipped for it.
         * @summary Create Job
         * @param {JobCreate} jobCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createJob: async (jobCreate: JobCreate, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'jobCreate' is not null or undefined
            assertParamExists('createJob', 'jobCreate', jobCreate)
            const localVarPath = `/jobs/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(jobCreate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get a single job with its most recent run expanded.  ``latest_run`` is ``None`` when the job has never run; otherwise its steps carry the ``name`` and ``identifier`` of the entity each targeted (``None`` when the entity no longer exists).
         * @summary Get Job
         * @param {string} jobId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getJob: async (jobId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'jobId' is not null or undefined
            assertParamExists('getJob', 'jobId', jobId)
            const localVarPath = `/jobs/{job_id}`
                .replace('{job_id}', encodeURIComponent(String(jobId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get a single job with its configured entities expanded as steps.  ``steps`` holds one entry per entity referenced by the job\'s ``configuration`` (in configuration order) with the entity\'s ``id``, ``entity_type`` and its display ``name`` / ``identifier`` (both ``None`` when the entity no longer exists). A container entity (e.g. a ``project_risk``) is followed by the entities it currently holds, each with ``resolved`` set to ``true`` and the container\'s id in ``parent_entity_id``; a directly configured entity has ``resolved`` ``false`` and no parent. Together they describe what the job *will* run, so they are populated even for a job that has never executed — unlike ``latest_run.steps``, which are the executions of the job\'s most recent run and are expanded exactly as in ``GET /jobs/{job_id}``.
         * @summary Get Job Expanded
         * @param {string} jobId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getJobExpanded: async (jobId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'jobId' is not null or undefined
            assertParamExists('getJobExpanded', 'jobId', jobId)
            const localVarPath = `/jobs/{job_id}/expanded`
                .replace('{job_id}', encodeURIComponent(String(jobId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get a single run of a job.  ``run_id`` is either a run UUID or the literal ``latest``, which resolves to the job\'s most recently created run.
         * @summary Get Job Run
         * @param {string} jobId 
         * @param {string} runId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getJobRun: async (jobId: string, runId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'jobId' is not null or undefined
            assertParamExists('getJobRun', 'jobId', jobId)
            // verify required parameter 'runId' is not null or undefined
            assertParamExists('getJobRun', 'runId', runId)
            const localVarPath = `/jobs/{job_id}/runs/{run_id}`
                .replace('{job_id}', encodeURIComponent(String(jobId)))
                .replace('{run_id}', encodeURIComponent(String(runId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get a single run of a job, expanded with its steps.  ``run_id`` is either a run UUID or the literal ``latest`` (the job\'s most recently created run). Every step carries the ``name`` and ``identifier`` of the entity it targeted, resolved per entity type (``None`` when the entity no longer exists), plus ``parent_entity_id`` / ``parent_entity_type`` — the container the step\'s entity belongs to (a ``risk_threat``\'s ``project_risk``), filled in from the entity itself when the run recorded none, and ``null`` for an entity type that has no container (a ``test``).
         * @summary Get Job Run Expanded
         * @param {string} jobId 
         * @param {string} runId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getJobRunExpanded: async (jobId: string, runId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'jobId' is not null or undefined
            assertParamExists('getJobRunExpanded', 'jobId', jobId)
            // verify required parameter 'runId' is not null or undefined
            assertParamExists('getJobRunExpanded', 'runId', runId)
            const localVarPath = `/jobs/{job_id}/runs/{run_id}/expanded`
                .replace('{job_id}', encodeURIComponent(String(jobId)))
                .replace('{run_id}', encodeURIComponent(String(runId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get all runs for a job.
         * @summary Get Job Runs
         * @param {string} jobId 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {RunSorting | null} [sortBy] 
         * @param {boolean | null} [descending] 
         * @param {JobStatus | null} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getJobRuns: async (jobId: string, page?: number, size?: number, sortBy?: RunSorting | null, descending?: boolean | null, status?: JobStatus | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'jobId' is not null or undefined
            assertParamExists('getJobRuns', 'jobId', jobId)
            const localVarPath = `/jobs/{job_id}/runs`
                .replace('{job_id}', encodeURIComponent(String(jobId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sort_by'] = sortBy;
            }

            if (descending !== undefined) {
                localVarQueryParameter['descending'] = descending;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get all runs for a job, each expanded with its steps.  Every step carries the ``name`` and ``identifier`` of the entity it targeted, resolved per entity type (``None`` when the entity no longer exists), plus the ``parent_entity_id`` / ``parent_entity_type`` of the container that entity belongs to, exactly as in ``GET /jobs/{job_id}/runs/{run_id}/expanded``.
         * @summary Get Job Runs Expanded
         * @param {string} jobId 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {RunSorting | null} [sortBy] 
         * @param {boolean | null} [descending] 
         * @param {JobStatus | null} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getJobRunsExpanded: async (jobId: string, page?: number, size?: number, sortBy?: RunSorting | null, descending?: boolean | null, status?: JobStatus | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'jobId' is not null or undefined
            assertParamExists('getJobRunsExpanded', 'jobId', jobId)
            const localVarPath = `/jobs/{job_id}/runs/expanded`
                .replace('{job_id}', encodeURIComponent(String(jobId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sort_by'] = sortBy;
            }

            if (descending !== undefined) {
                localVarQueryParameter['descending'] = descending;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get all jobs for a project.
         * @summary Get Jobs
         * @param {string} projectId 
         * @param {JobSorting | null} [sortBy] 
         * @param {boolean | null} [descending] 
         * @param {number} [page] Page number
         * @param {number} [size] Page size
         * @param {JobEntityType | null} [entityType] 
         * @param {JobStatus | null} [status] 
         * @param {string | null} [name] 
         * @param {boolean} [exactMatch] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getJobs: async (projectId: string, sortBy?: JobSorting | null, descending?: boolean | null, page?: number, size?: number, entityType?: JobEntityType | null, status?: JobStatus | null, name?: string | null, exactMatch?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('getJobs', 'projectId', projectId)
            const localVarPath = `/jobs/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (sortBy !== undefined) {
                localVarQueryParameter['sort_by'] = sortBy;
            }

            if (descending !== undefined) {
                localVarQueryParameter['descending'] = descending;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (projectId !== undefined) {
                localVarQueryParameter['project_id'] = projectId;
            }

            if (entityType !== undefined) {
                localVarQueryParameter['entity_type'] = entityType;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }

            if (exactMatch !== undefined) {
                localVarQueryParameter['exact_match'] = exactMatch;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get all steps for a run within a job.  ``run_id`` is either a run UUID or the literal ``latest`` (the job\'s most recently created run).
         * @summary Get Run Steps
         * @param {string} jobId 
         * @param {string} runId 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {StepSorting | null} [sortBy] 
         * @param {boolean | null} [descending] 
         * @param {JobStatus | null} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRunSteps: async (jobId: string, runId: string, page?: number, size?: number, sortBy?: StepSorting | null, descending?: boolean | null, status?: JobStatus | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'jobId' is not null or undefined
            assertParamExists('getRunSteps', 'jobId', jobId)
            // verify required parameter 'runId' is not null or undefined
            assertParamExists('getRunSteps', 'runId', runId)
            const localVarPath = `/jobs/{job_id}/runs/{run_id}/steps`
                .replace('{job_id}', encodeURIComponent(String(jobId)))
                .replace('{run_id}', encodeURIComponent(String(runId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sort_by'] = sortBy;
            }

            if (descending !== undefined) {
                localVarQueryParameter['descending'] = descending;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Enable or disable a job\'s schedule for future executions.  Only ``enabled`` is accepted. Disabling removes the job\'s schedule; enabling a job that has a schedule re-registers it. The job definition and its runtime status are untouched.  A job that backs a scheduled test\'s schedule keeps that test in sync: disabling it clears the test\'s ``schedule``, enabling it restores the job\'s cadence on the test (when the test can express it).
         * @summary Set Job Enabled
         * @param {string} jobId 
         * @param {JobEnabledUpdate} jobEnabledUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setJobEnabled: async (jobId: string, jobEnabledUpdate: JobEnabledUpdate, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'jobId' is not null or undefined
            assertParamExists('setJobEnabled', 'jobId', jobId)
            // verify required parameter 'jobEnabledUpdate' is not null or undefined
            assertParamExists('setJobEnabled', 'jobEnabledUpdate', jobEnabledUpdate)
            const localVarPath = `/jobs/{job_id}`
                .replace('{job_id}', encodeURIComponent(String(jobId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(jobEnabledUpdate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Stop a running execution of a job.  Only ``status`` is accepted, and the sole supported transition is to ``cancelled`` (Stop): the run and all of its unfinished steps are cancelled. The job\'s schedule is untouched, so a recurring job keeps its next run. ``run_id`` is either a run UUID or the literal ``latest``.
         * @summary Stop Job Run
         * @param {string} jobId 
         * @param {string} runId 
         * @param {RunUpdate} runUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stopJobRun: async (jobId: string, runId: string, runUpdate: RunUpdate, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'jobId' is not null or undefined
            assertParamExists('stopJobRun', 'jobId', jobId)
            // verify required parameter 'runId' is not null or undefined
            assertParamExists('stopJobRun', 'runId', runId)
            // verify required parameter 'runUpdate' is not null or undefined
            assertParamExists('stopJobRun', 'runUpdate', runUpdate)
            const localVarPath = `/jobs/{job_id}/runs/{run_id}`
                .replace('{job_id}', encodeURIComponent(String(jobId)))
                .replace('{run_id}', encodeURIComponent(String(runId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(runUpdate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Trigger an immediate (\"Run Now\") execution of a job.  Creates a Run and its Steps synchronously and enqueues one execution task per runnable Step; the created Run is returned right away. This is independent of the job\'s schedule, but not of the ``enabled`` flag: a disabled job never executes, so triggering one is rejected with 409.  Also rejects with 409 when the job already has a run in progress, so overlapping manual triggers (or a manual run overlapping a scheduled one) cannot race two runs to a non-deterministic terminal status.
         * @summary Trigger Job Run
         * @param {string} jobId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        triggerJobRun: async (jobId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'jobId' is not null or undefined
            assertParamExists('triggerJobRun', 'jobId', jobId)
            const localVarPath = `/jobs/{job_id}/runs`
                .replace('{job_id}', encodeURIComponent(String(jobId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Edit a job\'s definition for future executions.  ``entity_types`` (and its counts) are re-derived from ``configuration``; ``project_id`` and the job\'s runtime ``status`` are not editable. The schedule is re-registered to match the updated ``schedule`` and ``enabled`` flag. In-flight runs are left running.  As on ``POST /jobs``, a ``configuration`` entry may omit ``ids`` to select every entity of that type in the project — here it re-freezes the project\'s *current* entities onto the job, which is how a job is brought back in sync after entities were added or removed.  A job that backs a scheduled test\'s schedule mirrors its updated cadence onto that test, and clears the test\'s ``schedule`` when the job is disabled, loses its schedule, or moves to a cadence the test cannot express.
         * @summary Update Job
         * @param {string} jobId 
         * @param {JobUpdate} jobUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateJob: async (jobId: string, jobUpdate: JobUpdate, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'jobId' is not null or undefined
            assertParamExists('updateJob', 'jobId', jobId)
            // verify required parameter 'jobUpdate' is not null or undefined
            assertParamExists('updateJob', 'jobUpdate', jobUpdate)
            const localVarPath = `/jobs/{job_id}`
                .replace('{job_id}', encodeURIComponent(String(jobId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(jobUpdate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * JobsApi - functional programming interface
 */
export const JobsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = JobsApiAxiosParamCreator(configuration)
    return {
        /**
         * Create a job for a project.  The authenticated user becomes the job\'s creator. ``project_id`` is read from the request body, which is also how the RBAC dependency resolves the project. The job\'s ``entity_types`` are derived from ``configuration``: one entry per referenced entity type with the number of entities it covers (``count``) and how many of that type the job runs once container entities are expanded (``resolved``), followed by an entry per type its containers expand into (``count`` 0, ``resolved`` > 0). A container is never runnable itself, so it reports ``resolved`` 0.  A ``control_assessment`` entry references *controls*: each id is a control the job assesses with the control assessment agent, producing and storing one assessment per run.  A ``configuration`` entry may omit ``ids`` (or send ``null``) to select *every* entity of that type in the project: all of the project\'s ``test``s or ``agent_test``s, every control it assesses (for ``control_assessment``, excluding archived ones), all of its ``project_risk`` containers, or — for ``risk_threat`` — every threat held by every project risk. The selection is frozen into the job at creation, exactly as if each entity had been picked by hand, so entities added to the project later do not join the job and the response already lists the ids it captured. A type the project holds none of is rejected with 422, like an empty ``configuration``.  When the schedule\'s frequency is ``immediately`` the job runs once right after creation (a Run and its Steps are started) and is never scheduled to repeat. A job created disabled never executes, so the immediate run is skipped for it.
         * @summary Create Job
         * @param {JobCreate} jobCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createJob(jobCreate: JobCreate, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Job>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createJob(jobCreate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JobsApi.createJob']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get a single job with its most recent run expanded.  ``latest_run`` is ``None`` when the job has never run; otherwise its steps carry the ``name`` and ``identifier`` of the entity each targeted (``None`` when the entity no longer exists).
         * @summary Get Job
         * @param {string} jobId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getJob(jobId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<JobAggregate>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getJob(jobId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JobsApi.getJob']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get a single job with its configured entities expanded as steps.  ``steps`` holds one entry per entity referenced by the job\'s ``configuration`` (in configuration order) with the entity\'s ``id``, ``entity_type`` and its display ``name`` / ``identifier`` (both ``None`` when the entity no longer exists). A container entity (e.g. a ``project_risk``) is followed by the entities it currently holds, each with ``resolved`` set to ``true`` and the container\'s id in ``parent_entity_id``; a directly configured entity has ``resolved`` ``false`` and no parent. Together they describe what the job *will* run, so they are populated even for a job that has never executed — unlike ``latest_run.steps``, which are the executions of the job\'s most recent run and are expanded exactly as in ``GET /jobs/{job_id}``.
         * @summary Get Job Expanded
         * @param {string} jobId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getJobExpanded(jobId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<JobExpanded>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getJobExpanded(jobId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JobsApi.getJobExpanded']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get a single run of a job.  ``run_id`` is either a run UUID or the literal ``latest``, which resolves to the job\'s most recently created run.
         * @summary Get Job Run
         * @param {string} jobId 
         * @param {string} runId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getJobRun(jobId: string, runId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Run>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getJobRun(jobId, runId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JobsApi.getJobRun']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get a single run of a job, expanded with its steps.  ``run_id`` is either a run UUID or the literal ``latest`` (the job\'s most recently created run). Every step carries the ``name`` and ``identifier`` of the entity it targeted, resolved per entity type (``None`` when the entity no longer exists), plus ``parent_entity_id`` / ``parent_entity_type`` — the container the step\'s entity belongs to (a ``risk_threat``\'s ``project_risk``), filled in from the entity itself when the run recorded none, and ``null`` for an entity type that has no container (a ``test``).
         * @summary Get Job Run Expanded
         * @param {string} jobId 
         * @param {string} runId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getJobRunExpanded(jobId: string, runId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ModulosPlatformBackendV2DomainEntitiesJobRunAggregate>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getJobRunExpanded(jobId, runId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JobsApi.getJobRunExpanded']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get all runs for a job.
         * @summary Get Job Runs
         * @param {string} jobId 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {RunSorting | null} [sortBy] 
         * @param {boolean | null} [descending] 
         * @param {JobStatus | null} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getJobRuns(jobId: string, page?: number, size?: number, sortBy?: RunSorting | null, descending?: boolean | null, status?: JobStatus | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RunPaginated>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getJobRuns(jobId, page, size, sortBy, descending, status, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JobsApi.getJobRuns']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get all runs for a job, each expanded with its steps.  Every step carries the ``name`` and ``identifier`` of the entity it targeted, resolved per entity type (``None`` when the entity no longer exists), plus the ``parent_entity_id`` / ``parent_entity_type`` of the container that entity belongs to, exactly as in ``GET /jobs/{job_id}/runs/{run_id}/expanded``.
         * @summary Get Job Runs Expanded
         * @param {string} jobId 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {RunSorting | null} [sortBy] 
         * @param {boolean | null} [descending] 
         * @param {JobStatus | null} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getJobRunsExpanded(jobId: string, page?: number, size?: number, sortBy?: RunSorting | null, descending?: boolean | null, status?: JobStatus | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RunExpandedPaginated>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getJobRunsExpanded(jobId, page, size, sortBy, descending, status, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JobsApi.getJobRunsExpanded']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get all jobs for a project.
         * @summary Get Jobs
         * @param {string} projectId 
         * @param {JobSorting | null} [sortBy] 
         * @param {boolean | null} [descending] 
         * @param {number} [page] Page number
         * @param {number} [size] Page size
         * @param {JobEntityType | null} [entityType] 
         * @param {JobStatus | null} [status] 
         * @param {string | null} [name] 
         * @param {boolean} [exactMatch] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getJobs(projectId: string, sortBy?: JobSorting | null, descending?: boolean | null, page?: number, size?: number, entityType?: JobEntityType | null, status?: JobStatus | null, name?: string | null, exactMatch?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<JobPaginated>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getJobs(projectId, sortBy, descending, page, size, entityType, status, name, exactMatch, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JobsApi.getJobs']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get all steps for a run within a job.  ``run_id`` is either a run UUID or the literal ``latest`` (the job\'s most recently created run).
         * @summary Get Run Steps
         * @param {string} jobId 
         * @param {string} runId 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {StepSorting | null} [sortBy] 
         * @param {boolean | null} [descending] 
         * @param {JobStatus | null} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRunSteps(jobId: string, runId: string, page?: number, size?: number, sortBy?: StepSorting | null, descending?: boolean | null, status?: JobStatus | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StepPaginated>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRunSteps(jobId, runId, page, size, sortBy, descending, status, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JobsApi.getRunSteps']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Enable or disable a job\'s schedule for future executions.  Only ``enabled`` is accepted. Disabling removes the job\'s schedule; enabling a job that has a schedule re-registers it. The job definition and its runtime status are untouched.  A job that backs a scheduled test\'s schedule keeps that test in sync: disabling it clears the test\'s ``schedule``, enabling it restores the job\'s cadence on the test (when the test can express it).
         * @summary Set Job Enabled
         * @param {string} jobId 
         * @param {JobEnabledUpdate} jobEnabledUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setJobEnabled(jobId: string, jobEnabledUpdate: JobEnabledUpdate, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Job>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.setJobEnabled(jobId, jobEnabledUpdate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JobsApi.setJobEnabled']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Stop a running execution of a job.  Only ``status`` is accepted, and the sole supported transition is to ``cancelled`` (Stop): the run and all of its unfinished steps are cancelled. The job\'s schedule is untouched, so a recurring job keeps its next run. ``run_id`` is either a run UUID or the literal ``latest``.
         * @summary Stop Job Run
         * @param {string} jobId 
         * @param {string} runId 
         * @param {RunUpdate} runUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async stopJobRun(jobId: string, runId: string, runUpdate: RunUpdate, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Run>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.stopJobRun(jobId, runId, runUpdate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JobsApi.stopJobRun']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Trigger an immediate (\"Run Now\") execution of a job.  Creates a Run and its Steps synchronously and enqueues one execution task per runnable Step; the created Run is returned right away. This is independent of the job\'s schedule, but not of the ``enabled`` flag: a disabled job never executes, so triggering one is rejected with 409.  Also rejects with 409 when the job already has a run in progress, so overlapping manual triggers (or a manual run overlapping a scheduled one) cannot race two runs to a non-deterministic terminal status.
         * @summary Trigger Job Run
         * @param {string} jobId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async triggerJobRun(jobId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Run>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.triggerJobRun(jobId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JobsApi.triggerJobRun']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Edit a job\'s definition for future executions.  ``entity_types`` (and its counts) are re-derived from ``configuration``; ``project_id`` and the job\'s runtime ``status`` are not editable. The schedule is re-registered to match the updated ``schedule`` and ``enabled`` flag. In-flight runs are left running.  As on ``POST /jobs``, a ``configuration`` entry may omit ``ids`` to select every entity of that type in the project — here it re-freezes the project\'s *current* entities onto the job, which is how a job is brought back in sync after entities were added or removed.  A job that backs a scheduled test\'s schedule mirrors its updated cadence onto that test, and clears the test\'s ``schedule`` when the job is disabled, loses its schedule, or moves to a cadence the test cannot express.
         * @summary Update Job
         * @param {string} jobId 
         * @param {JobUpdate} jobUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateJob(jobId: string, jobUpdate: JobUpdate, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Job>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateJob(jobId, jobUpdate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JobsApi.updateJob']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * JobsApi - factory interface
 */
export const JobsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = JobsApiFp(configuration)
    return {
        /**
         * Create a job for a project.  The authenticated user becomes the job\'s creator. ``project_id`` is read from the request body, which is also how the RBAC dependency resolves the project. The job\'s ``entity_types`` are derived from ``configuration``: one entry per referenced entity type with the number of entities it covers (``count``) and how many of that type the job runs once container entities are expanded (``resolved``), followed by an entry per type its containers expand into (``count`` 0, ``resolved`` > 0). A container is never runnable itself, so it reports ``resolved`` 0.  A ``control_assessment`` entry references *controls*: each id is a control the job assesses with the control assessment agent, producing and storing one assessment per run.  A ``configuration`` entry may omit ``ids`` (or send ``null``) to select *every* entity of that type in the project: all of the project\'s ``test``s or ``agent_test``s, every control it assesses (for ``control_assessment``, excluding archived ones), all of its ``project_risk`` containers, or — for ``risk_threat`` — every threat held by every project risk. The selection is frozen into the job at creation, exactly as if each entity had been picked by hand, so entities added to the project later do not join the job and the response already lists the ids it captured. A type the project holds none of is rejected with 422, like an empty ``configuration``.  When the schedule\'s frequency is ``immediately`` the job runs once right after creation (a Run and its Steps are started) and is never scheduled to repeat. A job created disabled never executes, so the immediate run is skipped for it.
         * @summary Create Job
         * @param {JobsApiCreateJobRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createJob(requestParameters: JobsApiCreateJobRequest, options?: RawAxiosRequestConfig): AxiosPromise<Job> {
            return localVarFp.createJob(requestParameters.jobCreate, options).then((request) => request(axios, basePath));
        },
        /**
         * Get a single job with its most recent run expanded.  ``latest_run`` is ``None`` when the job has never run; otherwise its steps carry the ``name`` and ``identifier`` of the entity each targeted (``None`` when the entity no longer exists).
         * @summary Get Job
         * @param {JobsApiGetJobRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getJob(requestParameters: JobsApiGetJobRequest, options?: RawAxiosRequestConfig): AxiosPromise<JobAggregate> {
            return localVarFp.getJob(requestParameters.jobId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get a single job with its configured entities expanded as steps.  ``steps`` holds one entry per entity referenced by the job\'s ``configuration`` (in configuration order) with the entity\'s ``id``, ``entity_type`` and its display ``name`` / ``identifier`` (both ``None`` when the entity no longer exists). A container entity (e.g. a ``project_risk``) is followed by the entities it currently holds, each with ``resolved`` set to ``true`` and the container\'s id in ``parent_entity_id``; a directly configured entity has ``resolved`` ``false`` and no parent. Together they describe what the job *will* run, so they are populated even for a job that has never executed — unlike ``latest_run.steps``, which are the executions of the job\'s most recent run and are expanded exactly as in ``GET /jobs/{job_id}``.
         * @summary Get Job Expanded
         * @param {JobsApiGetJobExpandedRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getJobExpanded(requestParameters: JobsApiGetJobExpandedRequest, options?: RawAxiosRequestConfig): AxiosPromise<JobExpanded> {
            return localVarFp.getJobExpanded(requestParameters.jobId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get a single run of a job.  ``run_id`` is either a run UUID or the literal ``latest``, which resolves to the job\'s most recently created run.
         * @summary Get Job Run
         * @param {JobsApiGetJobRunRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getJobRun(requestParameters: JobsApiGetJobRunRequest, options?: RawAxiosRequestConfig): AxiosPromise<Run> {
            return localVarFp.getJobRun(requestParameters.jobId, requestParameters.runId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get a single run of a job, expanded with its steps.  ``run_id`` is either a run UUID or the literal ``latest`` (the job\'s most recently created run). Every step carries the ``name`` and ``identifier`` of the entity it targeted, resolved per entity type (``None`` when the entity no longer exists), plus ``parent_entity_id`` / ``parent_entity_type`` — the container the step\'s entity belongs to (a ``risk_threat``\'s ``project_risk``), filled in from the entity itself when the run recorded none, and ``null`` for an entity type that has no container (a ``test``).
         * @summary Get Job Run Expanded
         * @param {JobsApiGetJobRunExpandedRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getJobRunExpanded(requestParameters: JobsApiGetJobRunExpandedRequest, options?: RawAxiosRequestConfig): AxiosPromise<ModulosPlatformBackendV2DomainEntitiesJobRunAggregate> {
            return localVarFp.getJobRunExpanded(requestParameters.jobId, requestParameters.runId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get all runs for a job.
         * @summary Get Job Runs
         * @param {JobsApiGetJobRunsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getJobRuns(requestParameters: JobsApiGetJobRunsRequest, options?: RawAxiosRequestConfig): AxiosPromise<RunPaginated> {
            return localVarFp.getJobRuns(requestParameters.jobId, requestParameters.page, requestParameters.size, requestParameters.sortBy, requestParameters.descending, requestParameters.status, options).then((request) => request(axios, basePath));
        },
        /**
         * Get all runs for a job, each expanded with its steps.  Every step carries the ``name`` and ``identifier`` of the entity it targeted, resolved per entity type (``None`` when the entity no longer exists), plus the ``parent_entity_id`` / ``parent_entity_type`` of the container that entity belongs to, exactly as in ``GET /jobs/{job_id}/runs/{run_id}/expanded``.
         * @summary Get Job Runs Expanded
         * @param {JobsApiGetJobRunsExpandedRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getJobRunsExpanded(requestParameters: JobsApiGetJobRunsExpandedRequest, options?: RawAxiosRequestConfig): AxiosPromise<RunExpandedPaginated> {
            return localVarFp.getJobRunsExpanded(requestParameters.jobId, requestParameters.page, requestParameters.size, requestParameters.sortBy, requestParameters.descending, requestParameters.status, options).then((request) => request(axios, basePath));
        },
        /**
         * Get all jobs for a project.
         * @summary Get Jobs
         * @param {JobsApiGetJobsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getJobs(requestParameters: JobsApiGetJobsRequest, options?: RawAxiosRequestConfig): AxiosPromise<JobPaginated> {
            return localVarFp.getJobs(requestParameters.projectId, requestParameters.sortBy, requestParameters.descending, requestParameters.page, requestParameters.size, requestParameters.entityType, requestParameters.status, requestParameters.name, requestParameters.exactMatch, options).then((request) => request(axios, basePath));
        },
        /**
         * Get all steps for a run within a job.  ``run_id`` is either a run UUID or the literal ``latest`` (the job\'s most recently created run).
         * @summary Get Run Steps
         * @param {JobsApiGetRunStepsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRunSteps(requestParameters: JobsApiGetRunStepsRequest, options?: RawAxiosRequestConfig): AxiosPromise<StepPaginated> {
            return localVarFp.getRunSteps(requestParameters.jobId, requestParameters.runId, requestParameters.page, requestParameters.size, requestParameters.sortBy, requestParameters.descending, requestParameters.status, options).then((request) => request(axios, basePath));
        },
        /**
         * Enable or disable a job\'s schedule for future executions.  Only ``enabled`` is accepted. Disabling removes the job\'s schedule; enabling a job that has a schedule re-registers it. The job definition and its runtime status are untouched.  A job that backs a scheduled test\'s schedule keeps that test in sync: disabling it clears the test\'s ``schedule``, enabling it restores the job\'s cadence on the test (when the test can express it).
         * @summary Set Job Enabled
         * @param {JobsApiSetJobEnabledRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setJobEnabled(requestParameters: JobsApiSetJobEnabledRequest, options?: RawAxiosRequestConfig): AxiosPromise<Job> {
            return localVarFp.setJobEnabled(requestParameters.jobId, requestParameters.jobEnabledUpdate, options).then((request) => request(axios, basePath));
        },
        /**
         * Stop a running execution of a job.  Only ``status`` is accepted, and the sole supported transition is to ``cancelled`` (Stop): the run and all of its unfinished steps are cancelled. The job\'s schedule is untouched, so a recurring job keeps its next run. ``run_id`` is either a run UUID or the literal ``latest``.
         * @summary Stop Job Run
         * @param {JobsApiStopJobRunRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stopJobRun(requestParameters: JobsApiStopJobRunRequest, options?: RawAxiosRequestConfig): AxiosPromise<Run> {
            return localVarFp.stopJobRun(requestParameters.jobId, requestParameters.runId, requestParameters.runUpdate, options).then((request) => request(axios, basePath));
        },
        /**
         * Trigger an immediate (\"Run Now\") execution of a job.  Creates a Run and its Steps synchronously and enqueues one execution task per runnable Step; the created Run is returned right away. This is independent of the job\'s schedule, but not of the ``enabled`` flag: a disabled job never executes, so triggering one is rejected with 409.  Also rejects with 409 when the job already has a run in progress, so overlapping manual triggers (or a manual run overlapping a scheduled one) cannot race two runs to a non-deterministic terminal status.
         * @summary Trigger Job Run
         * @param {JobsApiTriggerJobRunRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        triggerJobRun(requestParameters: JobsApiTriggerJobRunRequest, options?: RawAxiosRequestConfig): AxiosPromise<Run> {
            return localVarFp.triggerJobRun(requestParameters.jobId, options).then((request) => request(axios, basePath));
        },
        /**
         * Edit a job\'s definition for future executions.  ``entity_types`` (and its counts) are re-derived from ``configuration``; ``project_id`` and the job\'s runtime ``status`` are not editable. The schedule is re-registered to match the updated ``schedule`` and ``enabled`` flag. In-flight runs are left running.  As on ``POST /jobs``, a ``configuration`` entry may omit ``ids`` to select every entity of that type in the project — here it re-freezes the project\'s *current* entities onto the job, which is how a job is brought back in sync after entities were added or removed.  A job that backs a scheduled test\'s schedule mirrors its updated cadence onto that test, and clears the test\'s ``schedule`` when the job is disabled, loses its schedule, or moves to a cadence the test cannot express.
         * @summary Update Job
         * @param {JobsApiUpdateJobRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateJob(requestParameters: JobsApiUpdateJobRequest, options?: RawAxiosRequestConfig): AxiosPromise<Job> {
            return localVarFp.updateJob(requestParameters.jobId, requestParameters.jobUpdate, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for createJob operation in JobsApi.
 */
export interface JobsApiCreateJobRequest {
    readonly jobCreate: JobCreate
}

/**
 * Request parameters for getJob operation in JobsApi.
 */
export interface JobsApiGetJobRequest {
    readonly jobId: string
}

/**
 * Request parameters for getJobExpanded operation in JobsApi.
 */
export interface JobsApiGetJobExpandedRequest {
    readonly jobId: string
}

/**
 * Request parameters for getJobRun operation in JobsApi.
 */
export interface JobsApiGetJobRunRequest {
    readonly jobId: string

    readonly runId: string
}

/**
 * Request parameters for getJobRunExpanded operation in JobsApi.
 */
export interface JobsApiGetJobRunExpandedRequest {
    readonly jobId: string

    readonly runId: string
}

/**
 * Request parameters for getJobRuns operation in JobsApi.
 */
export interface JobsApiGetJobRunsRequest {
    readonly jobId: string

    readonly page?: number

    readonly size?: number

    readonly sortBy?: RunSorting | null

    readonly descending?: boolean | null

    readonly status?: JobStatus | null
}

/**
 * Request parameters for getJobRunsExpanded operation in JobsApi.
 */
export interface JobsApiGetJobRunsExpandedRequest {
    readonly jobId: string

    readonly page?: number

    readonly size?: number

    readonly sortBy?: RunSorting | null

    readonly descending?: boolean | null

    readonly status?: JobStatus | null
}

/**
 * Request parameters for getJobs operation in JobsApi.
 */
export interface JobsApiGetJobsRequest {
    readonly projectId: string

    readonly sortBy?: JobSorting | null

    readonly descending?: boolean | null

    /**
     * Page number
     */
    readonly page?: number

    /**
     * Page size
     */
    readonly size?: number

    readonly entityType?: JobEntityType | null

    readonly status?: JobStatus | null

    readonly name?: string | null

    readonly exactMatch?: boolean
}

/**
 * Request parameters for getRunSteps operation in JobsApi.
 */
export interface JobsApiGetRunStepsRequest {
    readonly jobId: string

    readonly runId: string

    readonly page?: number

    readonly size?: number

    readonly sortBy?: StepSorting | null

    readonly descending?: boolean | null

    readonly status?: JobStatus | null
}

/**
 * Request parameters for setJobEnabled operation in JobsApi.
 */
export interface JobsApiSetJobEnabledRequest {
    readonly jobId: string

    readonly jobEnabledUpdate: JobEnabledUpdate
}

/**
 * Request parameters for stopJobRun operation in JobsApi.
 */
export interface JobsApiStopJobRunRequest {
    readonly jobId: string

    readonly runId: string

    readonly runUpdate: RunUpdate
}

/**
 * Request parameters for triggerJobRun operation in JobsApi.
 */
export interface JobsApiTriggerJobRunRequest {
    readonly jobId: string
}

/**
 * Request parameters for updateJob operation in JobsApi.
 */
export interface JobsApiUpdateJobRequest {
    readonly jobId: string

    readonly jobUpdate: JobUpdate
}

/**
 * JobsApi - object-oriented interface
 */
export class JobsApi extends BaseAPI {
    /**
     * Create a job for a project.  The authenticated user becomes the job\'s creator. ``project_id`` is read from the request body, which is also how the RBAC dependency resolves the project. The job\'s ``entity_types`` are derived from ``configuration``: one entry per referenced entity type with the number of entities it covers (``count``) and how many of that type the job runs once container entities are expanded (``resolved``), followed by an entry per type its containers expand into (``count`` 0, ``resolved`` > 0). A container is never runnable itself, so it reports ``resolved`` 0.  A ``control_assessment`` entry references *controls*: each id is a control the job assesses with the control assessment agent, producing and storing one assessment per run.  A ``configuration`` entry may omit ``ids`` (or send ``null``) to select *every* entity of that type in the project: all of the project\'s ``test``s or ``agent_test``s, every control it assesses (for ``control_assessment``, excluding archived ones), all of its ``project_risk`` containers, or — for ``risk_threat`` — every threat held by every project risk. The selection is frozen into the job at creation, exactly as if each entity had been picked by hand, so entities added to the project later do not join the job and the response already lists the ids it captured. A type the project holds none of is rejected with 422, like an empty ``configuration``.  When the schedule\'s frequency is ``immediately`` the job runs once right after creation (a Run and its Steps are started) and is never scheduled to repeat. A job created disabled never executes, so the immediate run is skipped for it.
     * @summary Create Job
     * @param {JobsApiCreateJobRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createJob(requestParameters: JobsApiCreateJobRequest, options?: RawAxiosRequestConfig) {
        return JobsApiFp(this.configuration).createJob(requestParameters.jobCreate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get a single job with its most recent run expanded.  ``latest_run`` is ``None`` when the job has never run; otherwise its steps carry the ``name`` and ``identifier`` of the entity each targeted (``None`` when the entity no longer exists).
     * @summary Get Job
     * @param {JobsApiGetJobRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getJob(requestParameters: JobsApiGetJobRequest, options?: RawAxiosRequestConfig) {
        return JobsApiFp(this.configuration).getJob(requestParameters.jobId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get a single job with its configured entities expanded as steps.  ``steps`` holds one entry per entity referenced by the job\'s ``configuration`` (in configuration order) with the entity\'s ``id``, ``entity_type`` and its display ``name`` / ``identifier`` (both ``None`` when the entity no longer exists). A container entity (e.g. a ``project_risk``) is followed by the entities it currently holds, each with ``resolved`` set to ``true`` and the container\'s id in ``parent_entity_id``; a directly configured entity has ``resolved`` ``false`` and no parent. Together they describe what the job *will* run, so they are populated even for a job that has never executed — unlike ``latest_run.steps``, which are the executions of the job\'s most recent run and are expanded exactly as in ``GET /jobs/{job_id}``.
     * @summary Get Job Expanded
     * @param {JobsApiGetJobExpandedRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getJobExpanded(requestParameters: JobsApiGetJobExpandedRequest, options?: RawAxiosRequestConfig) {
        return JobsApiFp(this.configuration).getJobExpanded(requestParameters.jobId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get a single run of a job.  ``run_id`` is either a run UUID or the literal ``latest``, which resolves to the job\'s most recently created run.
     * @summary Get Job Run
     * @param {JobsApiGetJobRunRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getJobRun(requestParameters: JobsApiGetJobRunRequest, options?: RawAxiosRequestConfig) {
        return JobsApiFp(this.configuration).getJobRun(requestParameters.jobId, requestParameters.runId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get a single run of a job, expanded with its steps.  ``run_id`` is either a run UUID or the literal ``latest`` (the job\'s most recently created run). Every step carries the ``name`` and ``identifier`` of the entity it targeted, resolved per entity type (``None`` when the entity no longer exists), plus ``parent_entity_id`` / ``parent_entity_type`` — the container the step\'s entity belongs to (a ``risk_threat``\'s ``project_risk``), filled in from the entity itself when the run recorded none, and ``null`` for an entity type that has no container (a ``test``).
     * @summary Get Job Run Expanded
     * @param {JobsApiGetJobRunExpandedRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getJobRunExpanded(requestParameters: JobsApiGetJobRunExpandedRequest, options?: RawAxiosRequestConfig) {
        return JobsApiFp(this.configuration).getJobRunExpanded(requestParameters.jobId, requestParameters.runId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get all runs for a job.
     * @summary Get Job Runs
     * @param {JobsApiGetJobRunsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getJobRuns(requestParameters: JobsApiGetJobRunsRequest, options?: RawAxiosRequestConfig) {
        return JobsApiFp(this.configuration).getJobRuns(requestParameters.jobId, requestParameters.page, requestParameters.size, requestParameters.sortBy, requestParameters.descending, requestParameters.status, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get all runs for a job, each expanded with its steps.  Every step carries the ``name`` and ``identifier`` of the entity it targeted, resolved per entity type (``None`` when the entity no longer exists), plus the ``parent_entity_id`` / ``parent_entity_type`` of the container that entity belongs to, exactly as in ``GET /jobs/{job_id}/runs/{run_id}/expanded``.
     * @summary Get Job Runs Expanded
     * @param {JobsApiGetJobRunsExpandedRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getJobRunsExpanded(requestParameters: JobsApiGetJobRunsExpandedRequest, options?: RawAxiosRequestConfig) {
        return JobsApiFp(this.configuration).getJobRunsExpanded(requestParameters.jobId, requestParameters.page, requestParameters.size, requestParameters.sortBy, requestParameters.descending, requestParameters.status, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get all jobs for a project.
     * @summary Get Jobs
     * @param {JobsApiGetJobsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getJobs(requestParameters: JobsApiGetJobsRequest, options?: RawAxiosRequestConfig) {
        return JobsApiFp(this.configuration).getJobs(requestParameters.projectId, requestParameters.sortBy, requestParameters.descending, requestParameters.page, requestParameters.size, requestParameters.entityType, requestParameters.status, requestParameters.name, requestParameters.exactMatch, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get all steps for a run within a job.  ``run_id`` is either a run UUID or the literal ``latest`` (the job\'s most recently created run).
     * @summary Get Run Steps
     * @param {JobsApiGetRunStepsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getRunSteps(requestParameters: JobsApiGetRunStepsRequest, options?: RawAxiosRequestConfig) {
        return JobsApiFp(this.configuration).getRunSteps(requestParameters.jobId, requestParameters.runId, requestParameters.page, requestParameters.size, requestParameters.sortBy, requestParameters.descending, requestParameters.status, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Enable or disable a job\'s schedule for future executions.  Only ``enabled`` is accepted. Disabling removes the job\'s schedule; enabling a job that has a schedule re-registers it. The job definition and its runtime status are untouched.  A job that backs a scheduled test\'s schedule keeps that test in sync: disabling it clears the test\'s ``schedule``, enabling it restores the job\'s cadence on the test (when the test can express it).
     * @summary Set Job Enabled
     * @param {JobsApiSetJobEnabledRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public setJobEnabled(requestParameters: JobsApiSetJobEnabledRequest, options?: RawAxiosRequestConfig) {
        return JobsApiFp(this.configuration).setJobEnabled(requestParameters.jobId, requestParameters.jobEnabledUpdate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Stop a running execution of a job.  Only ``status`` is accepted, and the sole supported transition is to ``cancelled`` (Stop): the run and all of its unfinished steps are cancelled. The job\'s schedule is untouched, so a recurring job keeps its next run. ``run_id`` is either a run UUID or the literal ``latest``.
     * @summary Stop Job Run
     * @param {JobsApiStopJobRunRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public stopJobRun(requestParameters: JobsApiStopJobRunRequest, options?: RawAxiosRequestConfig) {
        return JobsApiFp(this.configuration).stopJobRun(requestParameters.jobId, requestParameters.runId, requestParameters.runUpdate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Trigger an immediate (\"Run Now\") execution of a job.  Creates a Run and its Steps synchronously and enqueues one execution task per runnable Step; the created Run is returned right away. This is independent of the job\'s schedule, but not of the ``enabled`` flag: a disabled job never executes, so triggering one is rejected with 409.  Also rejects with 409 when the job already has a run in progress, so overlapping manual triggers (or a manual run overlapping a scheduled one) cannot race two runs to a non-deterministic terminal status.
     * @summary Trigger Job Run
     * @param {JobsApiTriggerJobRunRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public triggerJobRun(requestParameters: JobsApiTriggerJobRunRequest, options?: RawAxiosRequestConfig) {
        return JobsApiFp(this.configuration).triggerJobRun(requestParameters.jobId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Edit a job\'s definition for future executions.  ``entity_types`` (and its counts) are re-derived from ``configuration``; ``project_id`` and the job\'s runtime ``status`` are not editable. The schedule is re-registered to match the updated ``schedule`` and ``enabled`` flag. In-flight runs are left running.  As on ``POST /jobs``, a ``configuration`` entry may omit ``ids`` to select every entity of that type in the project — here it re-freezes the project\'s *current* entities onto the job, which is how a job is brought back in sync after entities were added or removed.  A job that backs a scheduled test\'s schedule mirrors its updated cadence onto that test, and clears the test\'s ``schedule`` when the job is disabled, loses its schedule, or moves to a cadence the test cannot express.
     * @summary Update Job
     * @param {JobsApiUpdateJobRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateJob(requestParameters: JobsApiUpdateJobRequest, options?: RawAxiosRequestConfig) {
        return JobsApiFp(this.configuration).updateJob(requestParameters.jobId, requestParameters.jobUpdate, options).then((request) => request(this.axios, this.basePath));
    }
}

